import {AvatarPlaceholderColorClass, type AvatarPlaceholderProps} from './avatar-placeholder-icon.types';

/**
 * Maps a name to a deterministic avatar color
 */
export const getAvatarColorClassForName = (name?: string | null): AvatarPlaceholderColorClass => {
  const colorClasses = Object.values(AvatarPlaceholderColorClass);
  if (!name) {
    return colorClasses[0];
  }
  const hash = name.split('').reduce((accumulated, char) => accumulated + char.charCodeAt(0), 0);
  return colorClasses[hash % colorClasses.length];
};

/**
 * Derives both AvatarPlaceholderIcon placeholder props from a name
 */
export const getAvatarPlaceholderPropsForName = (name?: string | null): AvatarPlaceholderProps => {
  return {
    colorClass: getAvatarColorClassForName(name),
    placeholderLetter: name && name.length > 0 ? name[0].toUpperCase() : '',
  };
};
